import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { OrderTypeCodesEnum } from '@cemex-core/cmx-api';
import { PRODUCT_LINE_NAME_CODE } from '@ordersnproducts/modules/shared/constants/product-lines-codes';

@Injectable()
export class IsOnlineOrderFeature implements IFlagFeature {
  name = Features.IsOnlineOrder;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return (
      params &&
      params.businessLine &&
      params.country &&
      params.orderType &&
      params.businessLine === PRODUCT_LINE_NAME_CODE.CEMENT &&
      (params.orderType === OrderTypeCodesEnum.Sls ||
        params.orderType === OrderTypeCodesEnum.StandardOrder ||
        params.orderType === OrderTypeCodesEnum.SpecialInvoiceOrder) &&
      container[this.name].getValue().split(' ').includes(params.country.trim())
    );
  }
}
